import { BookingStatus } from "./booking";
import { IShipDispatcher } from "./shipDispatcher";

type StatisticVessel = {
    id: string;
    arrivalDays: number;
    arrivalCost: number;
    layDays: number;
    layCost: number;
    electricityQuantity: number;
    electricityCost: number;
    waterQuantity: number;
    waterCost: number;
    serviceCost: number;
    wayFeeCost: number;
    wasteQuantity: number;
    wasteCost: number;
    serviceSatCount: number;
    serviceSunCount: number;
    totalCost: number;
    count: number;
};

type StatisticBerthing = {
    id: string | null;
    count: number | null;
};

type LengthCount = {
    id: string | null;
    le100: number; // Less than or equal to 100
    gt100: number; // Greater than 100
    beds: number;
};

type StatisticDock = {
    id: string | null;
    arrivalDays: number;
    arrivalCost: number;
    layDays: number;
    layCost: number;
    electricityQuantity: number;
    electricityCost: number;
    waterQuantity: number;
    waterCost: number;
    serviceCost: number;
    wayFeeCost: number;
    wasteQuantity: number;
    wasteCost: number;
    serviceSatCount: number;
    serviceSunCount: number;
    totalCost: number;
    count: number;
};

export type StatsExpensePerShip = {
    ship: IShipDispatcher;
    stats: StatisticVessel;
    berthings: StatisticBerthing[] | null;
};

export type StatsExpensePerDock = {
    expenseStats1: StatisticDock;
    lengthCount: LengthCount;
};

export type StatsExpensePerShipAndDock = {
    managingCompany: string;
    owningCompany: string;
    shipName: string;
    layDays: number;
    arrivalDays: number;
    totalDays: number;
    dockName: string;
};

export type StatsBerthingsPerDock = {
    id: string;
    le110: number;
    gt110: number;
    beds: number;
};

export type StatsBookingPerStatus = {
    status: BookingStatus;
    count: number;
};

export type StatsDaysPerType = {
    arrivalDay: number;
    layDay: number;
    days2: number;
    days3: number;
    days4plus: number;
};

export type StatsCountShips = {
    count: number;
    le110: number;
    gt110: number;
    beds: number;
};

export type ExpenseStatsDock = {
    id: string;
    arrivalDays: number;
    arrivalCost: number;
    layDays: number;
    layCost: number;
    electricityQuantity: number;
    electricityCost: number;
    waterQuantity: number;
    waterCost: number;
    serviceCost: number;
    wayFeeCost: number;
    wasteQuantity: number;
    wasteCost: number;
    serviceSatCount: number;
    serviceSunCount: number;
    serviceRegularCount: number;
    serviceCount0: number;
    serviceCount1: number;
    serviceCount2: number;
    serviceCount3: number;
    serviceCount4: number;
    serviceCount5: number;
    totalCost: number;
    count: number;
    countInvoices: number;
};

export type DashboardStats = {
    berthingsPerDock: StatsBerthingsPerDock[];
    bookingPerStatus: StatsBookingPerStatus[];
    daysPerType: StatsDaysPerType[];
    countShips: StatsCountShips[];
    expenseStatsDock: ExpenseStatsDock[];
};

export const dashboardStatsInit: DashboardStats = {
    berthingsPerDock: [],
    bookingPerStatus: [],
    daysPerType: [],
    countShips: [],
    expenseStatsDock: [],
};

export type IVoyageExportStatBerthing = {
    dockName: string;
    arrival: number;
    departure: number;
};

export type IVoyageExportStat = {
    bookingId: number;
    invoiceAddress: string | null;
    contactDetails: string | null;
    charterCompany: string | null;
    destinationName: string | null;
    destinationZone?: string | null;
    status: string | null;
    areaPreference: string | null;
    arrivalTime: number | null;
    departureTime: number | null;
    berthings: IVoyageExportStatBerthing[] | null;
    voyageName: string | null;
    voyageStart: number | null;
    voyageEnd: number | null;
    voyageStartZone?: string | null;
    voyageEndZone?: string | null;
    shipName: string | null;
    shipEni: string | null;
};

export type ILdExpenseStat = {
    shipId: string;
    shipName: string;
    dockId: string;
    dockName: string;
    managingCompanyName: string;
    owningCompany: string;
    arrivalDays: number;
    arrivalCost: number;
    layDays: number;
    layCost: number;
    totalCost: number;
    count: number;
    countInvoices: number;
    destName?: string;
};

export type ILdExpensePerShipStat = {
    shipId: string;
    shipName: string;
    shipEni: string;
    shipMmsi: string;
    managingCompany: string;
    owningCompany: string;
    arrivalDays: number;
    arrivalCost: number;
    layDays: number;
    layCost: number;
    electricityQuantity: number;
    electricityCost: number;
    waterQuantity: number;
    waterCost: number;
    serviceCost: number;
    wayFeeCost: number;
    wasteQuantity: number;
    wasteCost: number;
    serviceSatCount: number;
    serviceSunCount: number;
    serviceRegularCount: number;
    totalCost: number;
    count: number;
    countInvoices: number;
    passengerBeds: number;
    arrivals?: {
        shipId: string;
        dockId: string | null;
        dockName: string | null;
        count: number;
    }[];
};
